
(function documentDefinition() {
    'use strict';
    angular.module('Actions')
        .service('documentAction', [
            '$translate', 'documentService', 'alerts', 'errorsExtend', '$q', 'authExtend', 'fileService', 'fileDownloader', 'documentTypeService', 'workflowService',
            function documentAction($translate, documentService, alerts, errors, $q, authExtend, fileService, fileDownloader, documentTypeService, workflowService) {

                this.downloadFiles = function downloadFiles(document) {
                    var defered = $q.defer();
                    var promise = defered.promise;
                    var tempVersion = (document.checkedOutById !== null && document.checkedOutById.toString() === authExtend.getUserId().toString());

                    fileService.downloadFilesDocument(document.id, tempVersion).then(function (result) {
                        var success = fileDownloader.saveAs(result.value, document.name + '.zip');

                        if (!success) {
                            errors.showError('Api failed');
                        }

                        defered.resolve(result);
                    }, function (error) {
                        if (error.status === 204) {
                            errors.showWarning('The document has no files');
                        } else {
                            errors.showError('Api failed');
                        }

                        defered.reject();
                    });

                    return promise;
                };

                this.masiveDownloadFilesDocument = function masiveDownloadFilesDocument(documents) {
                    var defered = $q.defer();
                    var promise = defered.promise;
                    
                    fileService.masiveDownloadFilesDocument(documents).then(function (result) {
                        var today = new Date();
                        var success = fileDownloader.saveAs(result.value, 'descarga' + today.getFullYear() + ("0" + (today.getMonth() + 1)).slice(-2) + ("0" + today.getDate()).slice(-2) + ("0" + today.getHours()).slice(-2) + '.zip');

                        if (!success) {
                            errors.showError('Api failed');
                        }

                        defered.resolve(result);
                    }, function (error) {
                        if (error.status === 204) {
                            errors.showWarning('The document has no files');
                        } else {
                            errors.showError('Api failed');
                        }

                        defered.reject();
                    });

                    return promise;
                };

                this.exportSelectedToExcel = function exportSelectedToExcel(documents) {
                    var defered = $q.defer();
                    var promise = defered.promise;

                    fileService.masiveDownloadFilesDocument(documents).then(function (result) {
                        var today = new Date();
                        var success = fileDownloader.saveAs(result.value, 'descarga' + today.getFullYear() + ("0" + (today.getMonth() + 1)).slice(-2) + ("0" + today.getDate()).slice(-2) + ("0" + today.getHours()).slice(-2) + '.zip');

                        if (!success) {
                            errors.showError('Api failed');
                        }

                        defered.resolve(result);
                    }, function (error) {
                        if (error.status === 204) {
                            errors.showWarning('The document has no files');
                        } else {
                            errors.showError('Api failed');
                        }

                        defered.reject();
                    });

                    return promise;
                };


                this.checkIn = function checkIn(docu, typeId) {
                    var defered = $q.defer();
                    var promise = defered.promise;

                    var checkInVersioned = authExtend.isInRole('DOCUMENTVERSIONED WRITE');
                    var accesCheckIn = authExtend.isInRole('DOCUMENT WRITE');

                    if (!typeId) {
                        typeId = docu.documentDocumentTypes ? docu.documentDocumentTypes[0].documentTypeId : docu.documentTypes[0].documentTypeId;
                    }

                    documentTypeService.isDoctypeInRole(['DOCUMENTVERSIONED WRITE'], typeId).then(function (r) { checkInVersioned = r; });
                    documentTypeService.isDoctypeInRole(['DOCUMENT WRITE'], typeId).then(function (r) { accesCheckIn = r; });

                    $translate(['Warning', 'CheckOutConfirmText', 'CheckInCreateVersionConfirmText', 'Yes', 'No']).then(function (translated) {
                        return alerts.confirm(translated.Warning, translated.CheckOutConfirmText, translated.Yes, translated.No).then(function getOk(result) {
                            if (!result) {
                                defered.reject();
                                return result;
                            }

                            var isNew = docu.versionId ? docu.versionId === 1 : docu.isNew;

                            if (checkInVersioned && accesCheckIn && !isNew) {
                                return alerts.confirm(translated.Warning, translated.CheckInCreateVersionConfirmText, translated.Yes, translated.No).then(function (createVersion) {

                                    return documentService.checkIn(createVersion, docu).then(function (doc) {
                                        errors.showSuccess('DocumentCheckInSucces');
                                        defered.resolve(doc);
                                    }, function (error) {
                                        errors.showError(error);
                                        defered.reject();
                                    });
                                });
                            } else {
                                return documentService.checkIn(checkInVersioned, docu).then(function getOks(doc) {
                                    errors.showSuccess('DocumentCheckInSucces');
                                    defered.resolve(doc);
                                }, function (error) {
                                    errors.showError(error);
                                    defered.reject();
                                });
                            }
                        });
                    });

                    return promise;
                };

                this.startWFAndCheckIn = function startWFAndCheckIn(docu) {
                    var defered = $q.defer();
                    var promise = defered.promise;

                    var checkInVersioned = authExtend.isInRole('DOCUMENTVERSIONED WRITE');
                    var accesCheckIn = authExtend.isInRole('DOCUMENT WRITE');

                    documentTypeService.isDoctypeInRole(['DOCUMENTVERSIONED WRITE'], docu.documentDocumentTypes ? docu.documentDocumentTypes[0].documentTypeId : docu.documentTypes[0].documentTypeId).then(function (r) { checkInVersioned = r; });
                    documentTypeService.isDoctypeInRole(['DOCUMENT WRITE'], docu.documentDocumentTypes ? docu.documentDocumentTypes[0].documentTypeId : docu.documentTypes[0].documentTypeId).then(function (r) { accesCheckIn = r; });

                    $translate(['Warning', 'CheckOutConfirmText', 'CheckInCreateVersionConfirmText', 'Yes', 'No']).then(function (translated) {
                        return alerts.confirm(translated.Warning, translated.CheckOutConfirmText, translated.Yes, translated.No).then(function getOk(result) {
                            if (!result) {
                                defered.reject();
                                return result;
                            }

                            var isNew = docu.versionId ? docu.versionId === 1 : docu.isNew;

                            if (checkInVersioned && accesCheckIn && !isNew) {
                                return alerts.confirm(translated.Warning, translated.CheckInCreateVersionConfirmText, translated.Yes, translated.No).then(function (createVersion) {

                                    return documentService.checkIn(createVersion, docu).then(function (doc) {
                                        return workflowService.startWorkFlow(doc.id, doc.name, doc.documentType, doc.versionId).then(function (result) {
                                            errors.showSuccess('WorkFlowStartedAndCheckInSuccessfully');
                                            defered.resolve(doc);
                                        }, function (error) {
                                            errors.showError(error);
                                        });
                                    }, function (error) {
                                        errors.showError(error);
                                        defered.reject();
                                    });
                                });
                            } else {
                                return documentService.checkIn(checkInVersioned, docu).then(function getOks(doc) {
                                    return workflowService.startWorkFlow(doc.id, doc.name, doc.documentType, doc.versionId).then(function (result) {
                                        errors.showSuccess('WorkFlowStartedAndCheckInSuccessfully');
                                        defered.resolve(doc);
                                    }, function (error) {
                                        errors.showError(error);
                                    });
                                }, function (error) {
                                    errors.showError(error);
                                    defered.reject();
                                });
                            }
                        });
                    });

                    return promise;
                };

                this.deleteDocument = function deleteDoc(docu) {
                    var defered = $q.defer();
                    var promise = defered.promise;

                    $translate(['Warning', 'DocumentDeleteConfirmText', 'Yes', 'No']).then(function (translated) {
                        return alerts.confirm(translated.Warning, translated.DocumentDeleteConfirmText, translated.Yes, translated.No).then(function getOk(result) {
                            if (!result) {
                                defered.reject();
                                return result;
                            }
                            return documentService.delete(docu).then(function getOks(doc) {
                                errors.showSuccess('DocumentDeleteSuccess');
                                defered.resolve(doc);

                            }, function (error) {
                                errors.showError(error);
                                defered.reject();
                            });
                        });
                    });

                    return promise;
                };

                this.checkOut = function checkOut(docu) {
                    var defered = $q.defer();
                    var promise = defered.promise;

                    documentService.checkout(docu)
                        .then(function getOk(result) {
                            errors.showSuccess('DocumentCheckOutSucces');
                            defered.resolve(result);

                        }, function (error) {
                            errors.showError(error);
                            defered.reject();
                        });

                    return promise;
                };
            }
        ]);

})();